export const DASHBOARD_REFRESH_EVENT = "gestock:dashboard-refresh"

export const notifyDashboardRefresh = () => {
  if (typeof window === "undefined") return
  window.dispatchEvent(new Event(DASHBOARD_REFRESH_EVENT))
}
